/**
 * @override King Living: FullHeroBannerFragment extended for CF-04 (headingImage as Image only).
 */

import gql from 'graphql-tag';

import {ActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/action-links.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullHeroBannerFragment = gql`
  ${ActionLinksFragment}
  ${BaseHeroBannerFragment}
  ${ImageFragment}
  ${RichTextBlockFragment}
  ${VideoFragment}

  fragment FullHeroBannerFragment on HeroBanner {
    ...BaseHeroBannerFragment

    backgroundMedia {
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
    backgroundVideoMobile {
      ...VideoFragment
    }
    body {
      ...RichTextBlockFragment
    }
    cta {
      ...ActionLinksFragment
    }
    headingImage {
      ... on Image {
        ...ImageFragment
      }
    }
    rightCta {
      ...ActionLinksFragment
    }
  }
`;
